import { isMobile } from 'react-device-detect'

import Collection from '@src/pages/[...slug]/components/collection/domains/Collection'

import MemoryBoundedLRUCache from '../../utils/memoryBoundedLRUCache'

interface CollectionCacheItem {
  collectionPage: Collection
  page: number
  hasPaginationTerminated: boolean
  scrollY: number
}

const COLLECTION_CACHE_EXPIRY = 5 * 60 * 1000 // 5 minutes
const LRU_CACHE_MAX_SIZE = isMobile ? 10 : 20 // 20MB
const LRU_CACHE_MAX_ITEMS = 3 // 3 items

// This is a singleton class that manages the collection cache
// We can create separate classes for different types of pages for PDP, Search, etc.
class CollectionCacheStateManager {
  private readonly lruCache: MemoryBoundedLRUCache
  private state: Record<string, CollectionCacheItem> = {}

  constructor() {
    this.lruCache = new MemoryBoundedLRUCache(LRU_CACHE_MAX_ITEMS, LRU_CACHE_MAX_SIZE)
    this.state = {}
  }

  setCollectionCache = (collectionCache: CollectionCacheItem, slug: string) => {
    this.state[slug] = collectionCache
  }

  getCollectionCache = (slug: string): CollectionCacheItem | null => {
    const cacheData = this.lruCache.get(slug)
    if (cacheData?.collectionCache && cacheData.cacheExpiry > Date.now()) {
      return cacheData.collectionCache
    }
    if (cacheData?.collectionCache) {
      this.clearCollectionCache(slug)
    }
    return null
  }

  publishCollectionCache = (slug: string, scrollY: number) => {
    this.lruCache.put(slug, {
      collectionCache: { ...this.state[slug], scrollY },
      cacheExpiry: Date.now() + COLLECTION_CACHE_EXPIRY,
    })
  }

  clearCollectionCache = (slug: string) => {
    this.lruCache.delete(slug)
  }
  deleteEntriesThatStartsWith = (slug: string) => {
    const cache = (this.lruCache as any).cache as Map<string, any>
    for (const key of cache.keys()) {
      if (key.startsWith(slug)) {
        this.lruCache.delete(key)
      }
    }
  }
}

const collectionCacheStateManager = new CollectionCacheStateManager()

export default collectionCacheStateManager
